(() => {

	const gmapExists = document.querySelector('.poi-map');
	
	if(gmapExists) {
		let map;
		const gmapId = document.querySelector('.poi-map').id;
		const gmap = document.getElementById(gmapId);
		const lat = parseFloat(gmap.dataset.latitude);
		const lng = parseFloat(gmap.dataset.longitude);
		const latlng = new google.maps.LatLng(lat, lng);
		const markerIcon = gmap.dataset.markericon ?  new google.maps.MarkerImage(gmap.dataset.markericon) : '';

		const initMap = () => {
			const init = new Promise(function (resolve, reject) {

				map = new google.maps.Map(gmap, {
					zoom: Number(gmap.dataset.zoom),
					center: latlng,
					disableDefaultUI: gmap.dataset.disableui === 'True',
					zoomControl: gmap.dataset.enablezoom === 'True',
				});

				if (map != undefined) {
					resolve('map was successfully created');
				} else {
					reject(new Error('initMap() >> initialization problem'));
				}
			});
			init.then(setMarker()).catch(err => console.log(err));
		};

		const setMarker = () => {
			new google.maps.Marker({
				position: latlng,
				map: map,
				icon: markerIcon,
				animation: google.maps.Animation.DROP
			});
		};

		google.maps.event.addDomListener(window, 'load', initMap);
	}

})();


